import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/GenericServices/QuotationHistoryGS.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import filterIcon from '../../../Assets/TerminalHandling/filter-icon.svg'
class QuotationHistoryGS extends Component {
    constructor(props) {
        super(props)
        this.state = {
            search: "",
            searchlength: 0,
            quotationHisTempData: [],
            errorMessage: false,
            fliterValue: 'All',
            fliterValueDropDown: false,
            filterDataValues: [],
            quotationHisDetails: [
                {
                    'QuotationId': '101',
                    'orderDate': '1613110942',
                    'serviceType': 'Transportation Service',
                    'Status': 'Open'
                },
                {
                    'QuotationId': '102',
                    'orderDate': '1613110942',
                    'serviceType': 'Container Repair Service',
                    'Status': 'Closed'
                },
                {
                    'QuotationId': '103',
                    'orderDate': '1613110942',
                    'serviceType': 'Transportation Service',
                    'Status': 'Closed'
                },
                {
                    'QuotationId': '101',
                    'orderDate': '1613110942',
                    'serviceType': 'Container Repair Service',
                    'Status': 'Open'
                },
                {
                    'QuotationId': '102',
                    'orderDate': '1613110942',
                    'serviceType': 'Transportation Servic',
                    'Status': 'Open'
                },
                {
                    'QuotationId': '103',
                    'orderDate': '1613110942',
                    'serviceType': 'Clearing & Forwarding Service',
                    'Status': 'Closed'
                },
                {
                    'QuotationId': '101',
                    'orderDate': '1613110942',
                    'serviceType': 'Transportation Service',
                    'Status': 'Open'
                },
                {
                    'QuotationId': '102',
                    'orderDate': '1613110942',
                    'serviceType': 'Container Repair Service',
                    'Status': 'Closed'
                },
                {
                    'QuotationId': '103',
                    'orderDate': '1613110942',
                    'serviceType': 'Transportation Service',
                    'Status': 'Closed'
                },
                {
                    'QuotationId': '101',
                    'orderDate': '1613110942',
                    'serviceType': 'Container Repair Service',
                    'Status': 'Open'
                },
                {
                    'QuotationId': '102',
                    'orderDate': '1613110942',
                    'serviceType': 'Transportation Servic',
                    'Status': 'Open'
                },
                {
                    'QuotationId': '103',
                    'orderDate': '1613110942',
                    'serviceType': 'Clearing & Forwarding Service',
                    'Status': 'Closed'
                }
            ],
        }
        this.handlechangeSearchAppointmentNo = this.handlechangeSearchAppointmentNo.bind(this);
    }
    filterDataValues = [{ name: "All" }, { name: "Open" }, { name: "Closed" }]
    componentDidMount = () => {
    }
    handleDetails = (index) => {
        this.state.quotationHisTempData.find((truckdataStore) => {
            if (truckdataStore.QuotationId === this.state.quotationHisTempData[index].QuotationId) {
                //
            }
        })
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ fliterValueDropDown: false });
        }
    };
    toggleDropdownCargoPackaging = () => {
        this.setState({ fliterValueDropDown: !this.state.fliterValueDropDown });
    };
    changeFilterValue = (event) => {
        const found = this.filterDataValues.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ fliterValue: found.name });
        this.setState({ fliterValueDropDown: !this.state.fliterValueDropDown });
        if (found.name == 'Open') {
            const openFilter = this.state.quotationHisDetails.filter(i => i.Status == 'Open')
            console.log('abc--', openFilter)
            this.setState({
                quotationHisTempData: openFilter
            })
        } else if (found.name == 'Closed') {
            const closedFilter = this.state.quotationHisDetails.filter(i => i.Status == 'Closed')
            console.log('abc----', closedFilter)
            this.setState({
                quotationHisTempData: closedFilter
            })
        }
        else {
            this.setState({
                quotationHisTempData: this.state.quotationHisDetails
            })
        }
    }
    handlechangeSearchAppointmentNo = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value.length,
            errorMessage: false
        });
    };
    searchByOrderId = () => {
        if (this.state.searchlength > 0) {
            const truckdatafilter = this.state.quotationHisDetails.filter(i => i.QuotationId == this.state.search)
            console.log('a---', truckdatafilter);
            this.setState({ quotationHisTempData: truckdatafilter });
            if (truckdatafilter.length === 0) {
                this.setState({ errorMessage: true });
            }
            else {
                this.setState({ errorMessage: false });
            }
            console.log("inside search function", this.state.quotationHisTempData);
        }
    }
    render() {
        if (this.state.searchlength == 0 && this.state.fliterValue === 'All') {
            this.state.quotationHisTempData = this.state.quotationHisDetails;
        }
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.QuotationHistoryGSTitle} description={TitleDescription.QuotationHistoryGSDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullTruckAppointment">
                    <div id="csnobox111">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Service Request History</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="QuotationHisMainCard">
                            <div class="QuotationHisSearchUprDiv">
                                <div class="QuotationHisSearchDiv">
                                    <input
                                        className="appointmentSearch"
                                        placeholder="Search by Service Request ID"
                                        autoComplete="off"
                                        id="quotationHisDropDownCss"
                                        onChange={this.handlechangeSearchAppointmentNo}
                                        value={this.state.search}
                                    ></input>
                                    <img onClick={this.searchByOrderId} id="QuotationFilter_imgDrop" src={searchimg} width="16" height="16" />
                                </div>
                                <div class="QuotationFilterDiv">
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            readOnly name="CargoPackaging" class="input" placeholder=""
                                            type="text" id="quotationHisDropDownCss" value={this.state.fliterValue}
                                        />
                                        <i id="Quotation_imgDrop" onClick={this.toggleDropdownCargoPackaging}>
                                            <img src={filterIcon} />
                                        </i>
                                    </div>
                                    {this.state.fliterValueDropDown && (
                                        <div class="CrtTptReqestDropDowmDiv" >
                                            <div class="CrtTptReqestDropCard" ref={this.container} >
                                                {(this.filterDataValues.map((name, index) => {
                                                    return (
                                                        <DropDownTable onClick={(val) => this.changeFilterValue(val)} id="CrtTptReqestDropRowSize">
                                                            <small class="" id="CrtTptReqestDropRowText" >{name.name} </small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div id="QuotationHisTopDiv">
                                {!this.state.errorMessage ?
                                    (this.state.quotationHisTempData.map((name, index) => {
                                        return (
                                            <div class="QuotationHisMainCardDiv" onClick={() => this.handleDetails(index)}>
                                                <div class="QuotationHisDivRow" >
                                                    <div class="QuotationHisMainColumn1">
                                                        <div class='QuotationHisMainColumn' id='QuotationDiv1'>
                                                            <small id="QuotationHisLable">Service Request ID</small>
                                                            <small id='QuotationHisValue'>{name.QuotationId}</small>
                                                        </div>
                                                        <div class='QuotationHisMainColumn' id='QuotationDiv2'>
                                                            <small id="QuotationHisLable">Service Request Date & Time</small>
                                                            <small id='QuotationHisValue'>{FormatTimeStamp(name.orderDate).timedateToLocale}</small>
                                                        </div>
                                                        <div class='QuotationHisMainColumn' id='QuotationDiv3'>
                                                            <small id="QuotationHisLable">Service Type</small>
                                                            <small id='QuotationHisValue'>{name.serviceType}</small>
                                                        </div>
                                                        <div class='QuotationHisMainColumn' id='QuotationDiv4'>
                                                            <small id="QuotationHisLable">Status</small>
                                                            <small id={name.Status == 'Open' ? 'QuotationHisValueGreen' : "QuotationHisValue"}>{name.Status}</small>
                                                        </div>
                                                    </div>
                                                    <div class="QuotationHisArrow" >
                                                        <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }))
                                    :
                                    <div class="NoQuotationHistory">
                                        <small id="nodatamessage1">No result found</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="QuotationHistoryFooter1">
                    <Footer />
                </div>
                <div class="QuotationHistoryFooter2">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default QuotationHistoryGS;